import React from "react";
import "./home.scss";
import avatar from "../../assets/avatar-1.jpg";
import SocialMedia from "../social-media/social-media";
import Breakpoint from "react-socks";

const home = () => {
  return (
    <div>
      <Breakpoint medium up className="social-media-bar">
        <SocialMedia />
      </Breakpoint>

      <div className="mx-md-auto">
        <section id="home" className="container">
          <div className="row d-flex justify-content-around">
            <div className="col-12 col-md-5 my-md-auto">
              <h3 className="text-4 text-md-2">Hi, my name is</h3>
              <h2 className="title-1 title-md-1 color-lighter">
                Vipul Zambare.
              </h2>
              <h3 className="title-3 title-md-2 pt-md-3">
                I am passionate about building softwares to simplify human
                lives.
              </h3>
              <h3 className="text-4 text-md-4 pt-4">
                I am full stack developer based in Singapore specializing in
                development of multi-tier web and mobile applications.
              </h3>
            </div>

            <Breakpoint small down>
              <div className="col-12 mx-auto pt-4">
                <img className="avatar-mobile" src={avatar} alt="avatar" />
              </div>
            </Breakpoint>

            <Breakpoint medium up className="col-md-5 text-center">
              <img className="avatar" src={avatar} alt="avatar" />
            </Breakpoint>

            <Breakpoint medium up className="col-md-12">
              <div className="d-flex justify-content-center pt-5 mt-5">
                <a href="#about-me" className="btn-view-my-work">
                  About me
                </a>
              </div>
            </Breakpoint>
          </div>
        </section>
      </div>
    </div>
  );
};

export default home;
